export default __webpack_public_path__ + "static/media/sappi_icon.b9a86e6a.png";